import React from 'react';
import { Box } from '@mui/material';
import { CloudDownload as CloudDownloadIcon, PictureAsPdf as PictureAsPdfIcon } from '@mui/icons-material';
import BaseMUIDataTable from '../../components/BaseMUIDataTable/BaseMUIDataTable';
import { formatCsvFileName } from '../../helpers/formatters';
import { getMuiTableDataIndex } from '../../helpers/getters';
import TableActionsButtonsWrapper from '../../components/TableActionsButtonsWrapper';
import TableActionButton from '../../components/TableActionButton';

const TaxDocumentsTable = ({ taxDocuments, isLoading, onDownloadClick }) => (
  <BaseMUIDataTable
    tableId="#tax-documents/tax-documents-table"
    isLoading={isLoading}
    data={taxDocuments}
    columns={[
      {
        name: 'id',
        label: 'ID',
        options: {
          filter: false,
          sort: false,
          display: false,
          download: false,
        },
      },
      {
        name: 'name',
        label: 'Document',
        options: {
          customBodyRender: (value) => (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <PictureAsPdfIcon color="error" fontSize="small" />
              {value}
            </Box>
          ),
          customBodyRenderCSV: (value) => value,
        },
      },
      {
        name: 'reporting_period',
        label: 'Reporting Period Dates',
        options: {
          sort: false,
        },
      },
      {
        name: 'actions',
        label: 'Actions',
        options: {
          download: false,
          filter: false,
          sort: false,
          customBodyRender: (value, tableMeta) => (
            <TableActionsButtonsWrapper>
              <TableActionButton
                buttonProps={{
                  'data-testid': 'download-tax-document',
                  'row-id': taxDocuments[getMuiTableDataIndex(tableMeta)].id,
                }}
                icon={CloudDownloadIcon}
                title="Download Tax Document"
                onClick={() => onDownloadClick(taxDocuments[getMuiTableDataIndex(tableMeta)])}
              />
            </TableActionsButtonsWrapper>
          ),
        },
      },
    ]}
    options={{
      selectableRows: 'none',
      responsive: 'simple',
      downloadOptions: {
        filename: formatCsvFileName('Tax Documents'),
      },
    }}
  />
);

export default TaxDocumentsTable;
